import PropTypes from 'prop-types';
import { css, etiColors } from '@eti/styles';
import { Icon } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { traveler } from '@eti/utils';
import { seatMap } from '@eti/products';

const wrapperStyles = css`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  padding: 10px 0;

  &:not(:last-child) {
    border-bottom: 1px dotted ${etiColors.grayScale[7]};
  }
`;

const travelerIconStyles = css`
  position: relative;
`;

const initialsStyles = css`
  color: ${etiColors.white};
  font-size: 0.75rem;
  font-weight: 700;
  left: 8px;
  position: absolute;
  top: 8px;

  [dir='rtl'] & {
    left: 0;
    right: 8px;
  }
`;

const travelerStyles = css`
  color: ${etiColors.black};
  display: flex;
  flex-direction: column;
  font-size: 0.75rem;
  margin-left: 11px;

  [dir='rtl'] & {
    margin-left: 0;
    margin-right: 11px;
  }
`;

const informationStyles = css`
  display: flex;
`;

const ageTypeStyles = css`
  margin-left: 5px;

  [dir='rtl'] & {
    margin-left: 0;
    margin-right: 5px;
  }
`;

const seatSelectionStyles = css`
  display: flex;
`;

const textStyles = css`
  margin-right: 5px;

  [dir='rtl'] & {
    margin-left: 5px;
    margin-right: 0;
  }
`;

const seatStyles = css`
  margin-right: 5px;

  [dir='rtl'] & {
    margin-left: 5px;
    margin-right: 0;
  }
`;

const ReviewModalSeatTravelerInfo = ({ ageType, name, value }) => {
  const { t } = useTranslation();
  const travelerInitials = seatMap.getNameInitials(name);
  const adultLabel = t('Adult');
  const childLabel = t('Child');
  const infantLabel = t('Infant');

  return (
    <div className={wrapperStyles}>
      <div className={travelerIconStyles}>
        <Icon color={`${etiColors.info.solid}`} id="circle" size="32px" />
        <div className={initialsStyles}>{travelerInitials}</div>
      </div>
      <div className={travelerStyles}>
        <div className={informationStyles}>
          <div>{`${name},`}</div>
          <div className={ageTypeStyles}>
            {traveler.resolveLabelFromType(ageType, adultLabel, childLabel, infantLabel)}
          </div>
        </div>
        <div className={seatSelectionStyles}>
          <div className={textStyles}>{t('Product.SeatMap.Seat')}</div>
          <div className={seatStyles}>{value}</div>
        </div>
      </div>
    </div>
  );
};

ReviewModalSeatTravelerInfo.propTypes = {
  ageType: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
};

export default ReviewModalSeatTravelerInfo;
